module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-46.b669d0d3.png";